import "./JobHighlight.scss";

export const NewJob = () => {
  return <div className="jobHighlight">New!</div>;
};

export const FeaturedJob = () => {
  return <div className="jobHighlight featured">Featured</div>;
};
